import React from 'react';
import { useSelector } from 'react-redux';
import root from 'window-or-global';

import { selectIsAccountLoggedIn } from '../selectors/account.selector';
import { getLocale } from '../utils/local.utils';
import { selectConfigState } from '../selectors/config.selector';

export const useRequireLogin = () => {
    const isLoggedIn = useSelector(selectIsAccountLoggedIn);
    const configState = useSelector(selectConfigState);
    const lang = getLocale();
    const redirectUrl = root.location.href;
    const queryParams = new URLSearchParams({
        redirectUrl,
        lang
    });
    React.useEffect(() => {
        if (!isLoggedIn) {
            const logiUrl = `${configState.globalBase}/id/login?${queryParams.toString()}`;
            window.location.href = logiUrl;
        }
    }, []);
    return isLoggedIn;
};
